import { useTranslation } from 'react-i18next'
import { Salutation } from '@/api/customers'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { SALUTATION_LABEL_KEYS } from '@/components/customers/labels'

/** Herr, Frau, "–". Three values, so "no salutation" has exactly one representation. */
const ORDER = [Salutation.MR, Salutation.MS, Salutation.NONE] as const

export function SalutationSelect({
  id,
  value,
  onChange,
}: {
  id: string
  value: Salutation
  onChange: (value: Salutation) => void
}) {
  const { t } = useTranslation()

  return (
    <Select value={value} onValueChange={(next) => onChange(next as Salutation)}>
      <SelectTrigger id={id} className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {ORDER.map((salutation) => (
          <SelectItem key={salutation} value={salutation}>
            {t(SALUTATION_LABEL_KEYS[salutation])}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
